import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import {
  FDSwitchInput, FDTextInput, FDSelectInput,
} from '@facet-wealth/design';
import Agent, {
} from 'Classes/Agent';
import useHomeContext from 'Context/HomeContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import AgentDialogLayout from 'Components/AdvisorApp/Viewport/Users/AgentDialog/AgentDialogLayout';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['firstName', 'lastName', 'certificationTitle', 'calendarURL', 'zoomUrl', 'emailAddress', 'chilipiperCalendarLink'], {
    _component: () => FDTextInput,
    _customProps: {
      helperText: '',
    },
  }, overrideReadOnly)
  .nameOverride('biography', {
    _component: () => FDTextInput,
    _customProps: {
      helperText: '',
      rows: 6,
    },
  })
  .nameOverride(['role', 'plannerTier', 'teamCoach'], {
    _component: () => FDSelectInput,
    _customProps: {
      helperText: '',
    },
  }, overrideReadOnly)
  .nameOverride(['isSaveAgent', 'isTestUser', 'isWaitListAgent'], {
    _component: () => FDSwitchInput,
    _customProps: {
      helperText: '',
    },
  }, overrideReadOnly);

const AgentDialog = ({
  isAdd = true,
  agentProp = new Agent(),
  handleClose,
  refresh,
  openPlannerTransitionDialog,
}) => {
  const { homeResource } = useHomeContext();
  const [agentUserInfo, setAgentUserInfo] = useState(null);

  const fetchAgentUserInfo = async (relationship) => {
    if (!relationship) {
      return null;
    }

    const userInfo = await relationship.getRelated();
    if (!userInfo?.resources()?.head()) {
      const createdUserInfo = userInfo.create();
      setAgentUserInfo(createdUserInfo);
      return null;
    }

    setAgentUserInfo(userInfo.resources().head());
    return null;
  };

  useEffect(() => {
    if (agentUserInfo) {
      return null;
    }

    let relationship = agentProp.resource?.relationship(fr.relationships.agentUserInfo.name);
    if (isAdd) { // Do not copy this pattern. I am only doing it this way because agent is a very old endpoint. After the planner assignment feature is released, I will go back and clean this up.
      relationship = homeResource.relationship(fr.relationships.agentUserInfo.name);
    }

    fetchAgentUserInfo(relationship);

    return () => {
      setAgentUserInfo(null);
    };
  }, []);

  if (!agentUserInfo) {
    return null;
  }
  return (
    <MetaResourceRenderer
      resource={agentUserInfo}
      layout={AgentDialogLayout}
      metaOverrideSet={metaOverrideSet}
      LayoutProps={{
        handleClose, isAdd, openPlannerTransitionDialog, refresh,
      }}
    />
  );
};

export default AgentDialog;
